import { render } from "./StreamsManageNotifications.vue?vue&type=template&id=b81fdad8"
import script from "./StreamsManageNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageNotifications.vue?vue&type=script&setup=true&lang=js"

import "./StreamsManageNotifications.vue?vue&type=style&index=0&id=b81fdad8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManageNotifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b81fdad8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b81fdad8', __exports__)) {
    api.reload('b81fdad8', __exports__)
  }
  
  module.hot.accept("./StreamsManageNotifications.vue?vue&type=template&id=b81fdad8", () => {
    api.rerender('b81fdad8', render)
  })

}


export default __exports__